import * as z from "zod";
import { reconcileTenantAdminGrants } from "../rbac/tenantAdmins";
import { mutator } from "./mutator";

export const setTenantAdmins = mutator({
  schema: z.object({
    userIds: z.array(z.string()).min(1),
  }),
  resolve: {
    users: { kind: "user", from: "userIds", many: true },
  },
  permissions: [
    { permission: "allow_all", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args: { users } }) => {
    await reconcileTenantAdminGrants(
      tx,
      users.map((u) => u.id),
      ctx.tenantId
    );
  },
});
